<p class="mat-caption">
  <ng-content></ng-content>
</p>
